export default [
	"<section id=\"subject\" type=\"subject\">AI Generated Subject</section>",
	"<section id=\"previewText\" type=\"previewText\">AI Generated Preview Text</section>",
];
